<fa-icon
    [class.text-success]="value"
    [class.text-danger]="!value"
    [icon]="['fas', value ? 'check' : 'xmark']"
></fa-icon>
